/* tslint:disable */
/* eslint-disable */
/**
 * Risk Management System API
 * Risk Management System API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiAssignmentUser } from './ApiAssignmentUser';
import {
    ApiAssignmentUserFromJSON,
    ApiAssignmentUserFromJSONTyped,
    ApiAssignmentUserToJSON,
    ApiAssignmentUserToJSONTyped,
} from './ApiAssignmentUser';

/**
 * quick status comment for an Alert
 * @export
 * @interface ApiQuickStatusComment
 */
export interface ApiQuickStatusComment {
    /**
     * 
     * @type {number}
     * @memberof ApiQuickStatusComment
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ApiQuickStatusComment
     */
    status: string;
    /**
     * 
     * @type {string}
     * @memberof ApiQuickStatusComment
     */
    comment: string;
    /**
     * 
     * @type {Date}
     * @memberof ApiQuickStatusComment
     */
    createdTime: Date;
    /**
     * 
     * @type {ApiAssignmentUser}
     * @memberof ApiQuickStatusComment
     */
    createdBy?: ApiAssignmentUser;
    /**
     * 
     * @type {number}
     * @memberof ApiQuickStatusComment
     */
    sortOrder?: number;
}

/**
 * Check if a given object implements the ApiQuickStatusComment interface.
 */
export function instanceOfApiQuickStatusComment(value: object): value is ApiQuickStatusComment {
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('comment' in value) || value['comment'] === undefined) return false;
    if (!('createdTime' in value) || value['createdTime'] === undefined) return false;
    return true;
}

export function ApiQuickStatusCommentFromJSON(json: any): ApiQuickStatusComment {
    return ApiQuickStatusCommentFromJSONTyped(json, false);
}

export function ApiQuickStatusCommentFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiQuickStatusComment {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'status': json['status'],
        'comment': json['comment'],
        'createdTime': (new Date(json['createdTime'])),
        'createdBy': json['createdBy'] == null ? undefined : ApiAssignmentUserFromJSON(json['createdBy']),
        'sortOrder': json['sortOrder'] == null ? undefined : json['sortOrder'],
    };
}

export function ApiQuickStatusCommentToJSON(json: any): ApiQuickStatusComment {
    return ApiQuickStatusCommentToJSONTyped(json, false);
}

export function ApiQuickStatusCommentToJSONTyped(value?: ApiQuickStatusComment | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'status': value['status'],
        'comment': value['comment'],
        'createdTime': value['createdTime'].toISOString(),
        'createdBy': ApiAssignmentUserToJSON(value['createdBy']),
        'sortOrder': value['sortOrder'],
    };
}

